import axiosInstance from "app/axiosInstance";

export const getGeozoneById = async ({
  accountId,
  geozoneId
}: {
  accountId: string;
  geozoneId: string;
}) => {
  try {
    const response = await axiosInstance.get(
      `/accounts/${accountId}/geozones/${geozoneId}`
    );
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
